import PropTypes from 'prop-types';
import React from 'react';
import { ReactComponent as BusinessInitiatedIcon } from '../../assets/icons/business-initiated-icon.svg';
import { ReactComponent as CompletionIcon } from '../../assets/icons/completion-icon.svg';
import { ReactComponent as ConnectToSandboxIcon } from '../../assets/icons/connect-to-sandbox-icon.svg';
import { ReactComponent as UserInitiatedIcon } from '../../assets/icons/user-initiated-icon.svg';
import './_sandboxStepper.scss';

const SandboxStepper = ({ activeStep }) => {
    const steps = [
        {
            id: 1,
            name: 'Connect to Sandbox',
            icon: <ConnectToSandboxIcon />
        },
        {
            id: 2,
            name: 'Business-Initiated message',
            icon: <BusinessInitiatedIcon />
        },
        {
            id: 3,
            name: 'User-Initiated conversation',
            icon: <UserInitiatedIcon />
        },
        {
            id: 4,
            name: 'Completion',
            icon: <CompletionIcon />
        }
    ];

    return (
        <div className="sandbox-stepper-container">
            {steps.map((step, index) => (
                <React.Fragment key={step.id}>
                    <div className={`stepper-item ${activeStep === step.id ? 'active' : ''} ${activeStep > step.id ? 'completed' : ''}`}>
                        <div className="stepper-icon-container">
                            {step.icon}
                        </div>
                        <div className="stepper-text">{step.name}</div>
                    </div>
                    {index < steps.length - 1 && (
                        <span className="stepper-line">—</span>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

SandboxStepper.propTypes = {
    activeStep: PropTypes.number.isRequired
};

export default SandboxStepper; 